import styled from 'styled-components';

import { Icon as DefaultIcon } from 'components/UI/Icons/Icon';
import { Dropdown as DefaultDropdown } from 'components/UI/Dropdown';
import { Typography } from 'components/UI/Typography';

export const DropdownScrollContainer = styled.div`
	width: 100%;
	overflow-y: auto;
	max-height: calc(100vh - 42rem);
	min-height: 5rem;
`;

export const Dropdown = styled(DefaultDropdown)`
	padding: 0;
	width: auto;
	display: flex;
`;

export const DropdownHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	padding: 1rem;

	:hover {
		> :last-child {
			visibility: visible;
		}
	}
`;

export const DropdownTitle = styled(Typography.Paragraph)`
	padding-left: 1rem;
`;

export const ResetFilterIcon = styled(DefaultIcon)`
	visibility: hidden;
`;

export const NoResults = styled(Typography.Paragraph)`
	padding: 1.5rem 0 1rem 2rem;
`;
